import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

// When the user clicks the source links from the ai generated answer
export const onAIAnswerSourceClick: ({
	sourceIndex,
	isCitation,
	isAuxClick,
	isContextMenu,
	hostname,
	sourceCardType,
	sourceProduct,
	is3PSource,
	...props
}: commonAttributesType & {
	sourceIndex?: number;
	isCitation?: boolean;
	isAuxClick?: boolean;
	isContextMenu?: boolean;
	hostname?: string;
	sourceCardType?: string;
	is3PSource?: boolean;
}) => AnalyticsEventPayload = ({
	sourceIndex,
	isCitation,
	isAuxClick,
	isContextMenu,
	hostname,
	sourceCardType,
	sourceProduct,
	is3PSource,
	...props
}: commonAttributesType & {
	sourceIndex?: number;
	isCitation?: boolean;
	isAuxClick?: boolean;
	isContextMenu?: boolean;
	hostname?: string;
	sourceCardType?: string;
	is3PSource?: boolean;
}): AnalyticsEventPayload => {
	const { query, answerString, source } = props;
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerSourceLink',
		source: source,
		eventType: 'ui',
		attributes: {
			...filterCommonAttributes(props),
			sourceIndex,
			isCitation,
			isAuxClick,
			isContextMenu,
			sourceCardType,
			sourceProduct,
			is3PSource,
			...(hostname
				? {
						metadata: {
							hostname,
						},
					}
				: {}),
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
		},
	};
};
